export enum PRODUCT_ORIGIN_ENUMERATION {
  RP = 'RapiPlazo',
  RF = 'Rapiflex',
}

export enum PAYMENT_TYPE_ENUMERATION {
  REGULAR = 'PAYMENT',
  NOVATION = 'NOVATION',
  RENEGOTIATION = 'RENEGOTIATE',
}

export enum PRODUCT_TYPE_ENUMERATION {
  RP = 'RP',
}

export enum PRODUCT_STATE_ENUMERATION {
  OVERDUE = 'MORA',
  NOVATION_PENDING = 'PENDIENTE DE NOVACIÓN',
  DISBURSEMENT = 'DESEMBOLSADO',
}
